<template>
	<div>
		<!-- 关键字部分 -->
		<div class="pre_btn" v-show="show_key">
			<slot name="key_btn"></slot>
		</div>
		<!-- table部分 -->
		<div id="pre_tab" class="pre_tab" v-loading="fullloading" element-loading-text="拼命加载中......"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<table class="pre_dataintable_nokey">
				<thead>
					<slot name="tab_title"></slot>
				</thead>
				<tbody>
					<slot name="tab_tr" v-for="data_tr in data_tab" :item="data_tr"></slot>
					<slot name="tab_tr_all" :item="all_ammount"></slot>
				</tbody>
			</table>
		</div>
		<!-- 分页部分 -->
		<div class="pre_page" v-show="show_page">
			<ul style="text-align: right; margin-right: 20px;">
				<li>
					<span>分页:
						<input class="short-word-1" style="line-height: 24px;height: 24px;width: 48px;" type="text"
							v-model="page_length" @change="refresh_data('PAGE_LENGTH_CHANGE')" /></span>

					当前页：<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp; <a href="#"
						@click="firstpage">首页</a>|
					<a href="#" @click="beforepage">上一页</a>|
					<a href="#" @click="nextpage">下一页</a>|
					<a href="#" @click="lastpage">尾页</a>
					<input type="text" v-model="jumppage" value="" /><a href="#" @click="gopage" class="go">Go</a>
				</li>
			</ul>
		</div>
		<!-- 弹出向导层 start-->
		<div id="pop" class="pop" v-show="pop_show">
			<span class="pop_bg" @click="closeshow()"></span>
			<div id="pop_bodyup" class="pop_content">
				<div class="pop_head_close">
					<a class="close" href="javascript:void(0);" @click="hide()"></a>
				</div>
				<slot name="tab_addorupdate"></slot>
			</div>
		</div>
		<!-- 弹出向导层 end-->
	</div>
</template>
<script>
	/*
名称：Table组件 纯table+key
日期：2019-03-21
作者：hj

add 2020-11-08 替换等待提示和反馈提示为elementUI对应组件
*/

	// import '@/assets/css/pop.css';

	import {
		BrowserGet
	} from '@/utils/systemSelect.js';
	// import '@/assets/css/pre_table2.css';
	import {
		ReplaceAll,JsonCheck,ChangeSpecial
	} from '@/utils/method.js';
	
	export default {
		name: "pre_table_nokey",
		data() {
			return {
				data_tab: [],
				show_key: true,
				show_page: true,
				maxpage: '',
				nowpage: '',
				jumppage: '',
				fullloading: false,
				pop_show: false,
				show_btn_add: true,
				
				page_length: 20, //add 2022-01-25 默认分页长度
				/*备份 上一次的查询方式，如果方式改变,则应该重新初始化page*/
				back_sel_type: '',
				sel_key: '',
				temp_scroll: 0,
				all_ammount: {}
			};
		},
		props: {
			api_url: String,
			pre_post: String,
			/* 需要 增 删 改 就绑定这个 */
			pre_post_upd: {
				type: String,
				default: ''
			},
			/* 操作标记 当保存操作是不关闭窗口,提交则关闭窗口 就绑定这个 */
			pre_action: {
				type: String,
				default: ''
			}
		},
		created: function() {
			this.nowpage = 1;
			this.chang_style();
			this.$nextTick(function() {
				$('html,body').animate({
					scrollTop: '0px'
				}, 500);
			})
			if (BrowserGet() == 'firefox') {
				this.temp_scroll = 24;
			}
		},
		watch: {
			pre_post(val) {
				this.loaddata();
			},
			pre_post_upd(val) {
				if (String(val) != '')
					this.neworupdate();
			}
		},
		mounted: function() {
			this.initTable();
			this.loaddata();
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			window.addEventListener('scroll', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);
			// 这里只是操作dom
			window.addEventListener('resize', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);

			// this.$set(this.ischeck, 'isok', '1')
		},
		methods: {
			initTable: function() {
				if (Number(this.maxpage) == 0 || Number(this.maxpage) == 1) {
					this.show_page = false;
				} else {
					this.show_page = true;
				}
			},
			chang_style: function() {
				this.$nextTick(function() {
					var screenWidth = $(window).width();
					// var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
					// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
					let tw = 0,
						tleft = 0,
						tright = 0;
					tleft = $('#mleft').width();
					tright = $('#mright').width();
					tw = tright - 8;
					let css = '';
					css = 'width: ' + tw + 'px;max-width: ' + tw + 'px;';
					// console.log('左边宽度=' + tleft + '右边宽度=' + tright+'表格宽度=' + tw);
					// console.log(document.getElementById("mright"));
					// console.log($('#mright').width());

					var t = document.getElementById('pre_tab');
					// console.log(t);
					try {
						if (t == null) {
							// alert('11');
						} else {
							document.getElementById('pre_tab').style.cssText = css;
						}
					} catch (e) {}

				});
			},
			firstpage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage = 1;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			lastpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage = this.maxpage;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			gopage: function() {

				if (Number(this.jumppage) > 0 && Number(this.jumppage) <= Number(this.maxpage)) {
					this.nowpage = this.jumppage;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '跳转页数不在规定范围内,请检查' + this.jumppage,
						type: 'warning'
					});
				}
			},
			loaddata: function() {

				if (this.api_url == '' || this.pre_post == '') {
					// this.msg_obj = {
					//   'showtype': 'warning',
					//   'note': '请求数据不能空值'
					// };
					// console.log('请求数据不能空值' + '\r\n' + this.api_url + '\r\n' + this.pre_post);
					return;
				}

				this.fullloading = true;

				this.$post(
					this.api_url,
					this.pre_post,
				).then(res => {
					this.fullloading = false;
					this.data_tab = [];
					try {
						res = JSON.parse((res));
						if (Number.parseInt(res.data.status) == 1) {
							this.maxpage = res.data.allpage;
							if (Number(res.data.allpage) == 0) {
								this.$message({
									message: '没有查询到数据',
									type: 'success'
								});
							} else {
								this.data_tab = res.data.data;
								// console.log(this.data_tab);
								// 返回合计字段
								// var o={};
								// o.allamount=res.data.allamount;
								// o.allamount_up=res.data.allamount_up;
								// o.allamount_yj=res.data.allamount_yj;
								// this.all_ammount=o;


								// 每次刷新 后默认 点击刚刚的修改项目,返回给个标记,返回到父组件,通过父组件保留的修改项目ID来刷新点击项目 2019-06-25
								// this.refresh_data('sel');

								// 每次刷新 后默认 点击第一行  同时也是  刚刚修改项目 add 2019-06-05
								// document.getElementById("tr1").click();          //不行
							}
						} else {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});
						}
						this.initTable();
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});
			},
			refresh_data(action, tempdata) {
				// action   操作指示
				// tempdata 传输数据
				this.$emit("tab-event", this.nowpage, action, this.page_length,tempdata);
			},
			new_one_data: function() {
				this.data_tab.push({});
			},
			showpop: function() {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
			},
			hide: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
			},
			closeshow: function() {
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				// this.show_filedown=false;
			},
			neworupdate: function() {

				this.fullloading = true;
				this.$post(
					this.api_url,
					this.pre_post_upd,
				).then(res => {
					this.fullloading = false;
					// if(Number(this.pre_action=='1')){ this.pop_show=false;}
					// add 2019-06-25 实现联动操作后就不需要关闭窗口了
					this.pop_show = false;

					try {
						res = JSON.parse(res);
						// console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							let that = this;
							setTimeout(function() {
								that.loaddata();
							}, 100)

						} else {
							this.$message.error(res.data.msg);
						}
						// this.refresh_data('sel');
						// this.initTable();
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});
			},
			setCurrentRowNew: function(id, ty) {
				for (var i = 0; i < this.data_tab.length; i++) {
					if (this.data_tab[i].id == id) {
						document.getElementById(ty + id).style.background = '#92a4f3';
					} else {
						if (this.data_tab[i].id % 2 == 0) {
							document.getElementById(ty + this.data_tab[i].id).style.background = '#fff';
						} else {
							document.getElementById(ty + this.data_tab[i].id).style.background = '#f5f5f5';
						}
					}
				}
			},
			// 下面准备淘汰
			setCurrentRow: function(item, ty) {

				for (var i = 0; i < this.data_tab.length; i++) {

					if (this.data_tab[i].row_num == item.row_num) {
						document.getElementById(ty + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.data_tab[i].row_num % 2 == 0) {
							document.getElementById(ty + this.data_tab[i].row_num).style.background = '#fff';
						} else {
							document.getElementById(ty + this.data_tab[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
			}
		}
	};
</script>

<style scoped>
	/* pre_search */
	.pre_btn {
		text-align: left;
	}

	.pre_btn>label {
		position: relative;
		/* left: 2%; */
	}

	.pre_btn>input {
		position: relative;
		/* left: 2%; */
	}

	.pre_btn>input :focus {
		border: 1px solid #024aee;
		background-color: #aaa;
	}



	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_dataintable_nokey {
		width: auto;
		margin-top: 3px;
		table-layout: fixed;
		border-collapse: collapse;
		border-spacing: 0;
	}

	.pre_dataintable_nokey thead {
		display: table-row;
	}

	.pre_dataintable_nokey tbody {
		overflow-y: scroll;
		overflow-x: hidden;
		display: block;
		max-height: calc(100vh - 60px);

	}

	.pre_dataintable_nokey th,
	.pre_dataintable_nokey td {
		padding: 2px 6px 2px 6px;
		vertical-align: middle;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
		min-width: 96px;
		width: 1px;
		max-width: 96px;
		font-size: 14px;
		text-overflow: ellipsis;
		/* border: 1px solid #3f3f3f; */
		height: 24px;
		line-height: 22px;
	}

	.pre_dataintable_nokey thead td,
	.pre_dataintable_nokey th {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;

	}

	.pre_dataintable_nokey td {
		overflow: hidden;
		text-overflow: ellipsis;
		/* word-break:  keep-all; 避免长单词截断，保持全部 */
		border: 1px solid #808080;
		text-align: center;
	}

	.pre_dataintable_nokey tr th:nth-child(1),
	.pre_dataintable_nokey tr td:nth-child(1) {
		min-width: 48px;
		width: 48px;
	}

	.pre_dataintable_nokey tr td:nth-child(3) {
		text-align: left;
	}

	.pre_dataintable_nokey tr th:nth-child(8),
	.pre_dataintable_nokey tr td:nth-child(8) {
		min-width: 120px;
		width: 120px;
	}

	.pre_dataintable_nokey tr th:nth-last-child(2),
	.pre_dataintable_nokey tr td:nth-last-child(2) {
		min-width: 150px;
		width: 150px;
	}

	.pre_dataintable_nokey tr th:nth-last-child(1),
	.pre_dataintable_nokey tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.t_long {
		width: 240px !important;
		max-width: 240px !important;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: bolder;
		height: 24px;
		line-height: 22px;
	}

	/* 表格内按钮 */
	.pre_dataintable_nokey td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* button 这样设置没有起作用,用span 模拟代替 */
	.pre_dataintable_nokey td button :hover {
		/* width: 80px;
  padding: 6px 6px 6px 6px; */
		cursor: pointer;
		background-color: #819ec2 !important;
	}

	/* 表格内输入框 */
	.pre_dataintable_nokey td input {
		width: 100%;
		height: 100%;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
	}

	.pre_dataintable_nokey td img {
		width: 18px;
		height: 18px;
		border: 0px;
		text-align: left;
		/* font-size: 16px; */
		margin-left: 5px;
		margin-right: 5px;
	}

	.pre_dataintable_nokey td img:hover {
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_dataintable_nokey td span {
		display: inline-block;
		border: 1px solid black;
		background: #aaa;
		text-align: center;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 2px;
		margin-right: 2px;
	}

	.pre_dataintable_nokey td span:hover {
		background: rgb(88, 210, 226);
		/* font-size: 16px; */
	}

	.pre_dataintable_nokey tr {
		cursor: pointer;
		height: 27px;
		/* line-height: 27px; */
	}

	.pre_dataintable_nokey tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_dataintable_nokey tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_dataintable_nokey tr:hover {
		/* background-color: #b8f8b8 !important; */
		background-color: #B7D3F4 !important;
	}

	/* .pre_dataintable_nokey tr:focus {
  background-color: #92a4f3;
} */

	.tab_add {
		width: 95%;
		display: flex;
		margin-top: 5px;
		margin-left: 2%;
		background-color: rgba(103, 233, 77, 0.644);
	}

	.tab_upd {
		width: 95%;
		display: flex;
		margin-left: 2%;
		background-color: rgba(209, 212, 36, 0.644);
	}

	.pre_dataintable_nokey tr td ul li {
		float: left;
		margin-right: 2px;
	}

	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: 5px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}

	/* 表格自带弹出编辑区域 start */
	.pop_edit {
		display: inline-block;
		/* border: 1px solid black; */
		border-radius: 10px 10px 15px 10px;
		/* background-color: #409eff6b; */
		/* min-width: 800px; */
		overflow: hidden;
		/* padding: 5px; */
		margin-bottom: 10px;
		width: auto;
		/* max-width: 1280px; */
		background: rgb(195, 219, 250);
		text-align: left;
		padding: 20px;
	}

	.pop_edit_item {
		margin-top: 2px;
	}



	/* 表格自带弹出编辑区域 end */

	/* 单选样式 */

	.radio_val {
		width: 20px !important;
	}

	.data_down {
		width: 100%;
	}

	.data_down>div {
		margin-top: 10px;
	}

	/* .data_down > div >button {
	text-align: center;
} */
	.data_down>div>label {
		width: 80px;
		display: inline-block;
	}

	.data_down>div>input {
		width: 300px;
		display: inline-block;
	}

	/* 悬浮提示框 */
	/* Tooltip 容器 */
	.tooltip {
		position: relative;
		display: inline-block;
		/* border-bottom: 1px dotted black; 悬停元素上显示点线 */
		/* cursor: pointer; */
	}

	/* Tooltip 文本 */
	.tooltip .tooltiptext {
		visibility: hidden;
		min-width: 120px;
		width: 320px;
		height: auto;
		max-width: 320px;
		margin-top: 20px;
		background-color: rgb(20, 19, 19);
		color: rgb(239, 243, 240);
		white-space: pre-wrap;
		/* word-break: break-all; */
		text-align: left;
		padding: 5px 8px 5px 6px;
		border-radius: 6px;

		/* 定位 */
		position: absolute;
		z-index: 9999;
		top: 100%;
		left: 10%;
		margin-left: -60px;
	}

	.tooltip .tooltiptext::after {
		content: "";
		position: absolute;
		bottom: 100%;
		left: 50%;
		margin-left: -10px;
		/*  属性指定了箭头的大小。如果你修改它，也要修改 margin-left 值。这样箭头在能居中显示 */
		border-width: 10px;
		border-style: solid;
		border-color: transparent transparent rgb(20, 19, 19) transparent;
	}

	/* 鼠标移动上去后显示提示框 */
	.tooltip:hover .tooltiptext {
		visibility: visible;
	}

	/* <div class="tooltip">鼠标移动到这
  <span class="tooltiptext">提示文本</span>
</div> */
</style>